import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';

@Component({
    selector: 'app-age-restriction-modal',
    templateUrl: 'age-restriction-modal.component.html',
    styleUrls: ['age-restriction-modal.component.scss']
})
export class AgeRestrictionModalComponent
{
    @ViewChild('modal', { static: true })
    public modal: ModalComponent;

    public constructor()
    {
    }

    public onCloseClick(): void
    {
        this.modal.close('close clicked');
    }

    public open(): void
    {
        this.modal.open();
    }
}

